import GlobalHandler from '@/utils/global_handler';

const globalHandler = new GlobalHandler();
window.globalHandler = globalHandler;
export default globalHandler;
